import { MapPin } from "lucide-react";
import { Link } from "react-router-dom";

export const Logo = ({ size = "md" }) => {
  const iconSize = size === "lg" ? 30 : 22;
  const textSize = size === "lg" ? "text-3xl" : "text-xl";
  return (
    <Link to="/" data-testid="logo-link" className="flex items-center gap-2 group">
      <span className="relative flex items-center justify-center">
        <span className="absolute inset-0 rounded-full bg-[#FF453A]/30 pin-pulse" />
        <span className="relative flex items-center justify-center w-9 h-9 rounded-full bg-[#FF453A] glow-red">
          <MapPin size={iconSize - 4} className="text-white" strokeWidth={2.5} />
        </span>
      </span>
      <span className={`font-heading font-bold ${textSize} tracking-tight text-white`}>
        Pin<span className="text-[#FF453A]">Quests</span>
      </span>
    </Link>
  );
};

export default Logo;
